import { Component, OnInit, Input } from '@angular/core';
import { Product } from 'src/app/order/models/product.model';
import { OrderService } from 'src/app/order/services/order.service';
import { Unit } from 'src/app/order/models/unit.model';
import { ProductGroup } from 'src/app/order/models/product-group.model';
import { ProductClass } from 'src/app/warehousing/models/product-class.model';
import { WarehouseLocation } from 'src/app/warehousing/models/warehouse-location.model';
import { LookupService } from 'src/app/core/services/lookup.service';
import { AccountService } from 'src/app/account/services/account.service';
import { take, catchError } from 'rxjs/operators';

@Component({
    selector: 'app-product-form',
    templateUrl: './product-form.component.html',
    styleUrls: ['./product-form.component.scss'],
    standalone: false
})
export class ProductFormComponent implements OnInit {

  @Input()
  product: Product;

  units: Unit[] = [];
  productClasses: ProductClass[] = [];
  productGroups: ProductGroup[] = [];
  warehouseLocations: WarehouseLocation[] = [];
  accounts: any[] = [];

  constructor(private orderService: OrderService,
    private lookupService: LookupService,
    private accountService: AccountService) { }

  ngOnInit(): void {
    this.loadUnits();
    this.loadInventoryLookups();
    this.loadAccounts();
  }

  loadUnits() {
    this.orderService.getAllUnits()
    .pipe(take(1))
    .pipe(catchError((e) => {
      if(e.status === 403 || e.status === 401) {
        return e;
      }
      alert("Cannot load units");
      return e;
    }))
    .subscribe((data: Unit[]) => {
      this.units = data;
    })
  }

  loadInventoryLookups() {
    this.lookupService.getLookupList(['product_class', 'product_group', 'warehouse', 'warehouse_location'])
    .pipe(take(1))
    .pipe(catchError((e) => {
      if(e.status === 403 || e.status === 401) {
        return e;
      }
      alert("Cannot load inventory lookups");
      return e;
    }))
    .subscribe((data: any) => {
      this.productClasses = data['product_class'] ? data['product_class'] : [];
      this.productGroups = data['product_group'] ? data['product_group'] : [];

      const warehouses = data['warehouse'] ? data['warehouse'] : [];
      const locations = data['warehouse_location'] ? data['warehouse_location'] : [];

      // lookupList returns flat rows, so the warehouse for each location label is stitched here
      locations.forEach((location: WarehouseLocation) => {
        location.warehouse = warehouses.filter(w => w.id === location.warehouseId)[0];
      });

      this.warehouseLocations = locations;
    })
  }

  getLocationLabel(location: WarehouseLocation): string {
    const warehouseName = location.warehouse ? location.warehouse.name : 'Unknown warehouse';
    return warehouseName + ' - Aisle ' + location.aisle + ' / Shelf ' + location.shelf;
  }

  /** Customers only - the owner of 3PL stock is always one of them. */
  loadAccounts() {
    this.accountService.getAllAccountsForCustomerAndProspect()
    .pipe(take(1))
    .pipe(catchError((e) => {
      if(e.status === 403 || e.status === 401) {
        return e;
      }
      alert("Cannot load customers");
      return e;
    }))
    .subscribe((data: any) => {
      this.accounts = data;
    })
  }
}
